/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cookie[_ngcontent-%COMP%]{-webkit-transition:height .3s ease-in-out;transition:height .3s ease-in-out;width:100%;position:fixed;top:0;padding:0 10px;background-color:#000;color:#fff;overflow:hidden;z-index:1100}.cookie[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin:5px 0}.cookie[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:20px;background-color:transparent;border:0;color:#fff;cursor:pointer}.cookie[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{line-height:24px;color:#fff}@media only screen and (min-width:600px){.cookie[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin-left:20px}}.cookie[_ngcontent-%COMP%]   .accept[_ngcontent-%COMP%]{line-height:24px;border:1px solid #fff;color:#fff}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/common-theme/utils/cookie/cookie.component.scss.shim.ngstyle.js.pre-build-optimizer.js